import { render, staticRenderFns } from "./MyProfileDetails.vue?vue&type=template&id=5e668c10&scoped=true&"
import script from "./MyProfileDetails.vue?vue&type=script&lang=ts&"
export * from "./MyProfileDetails.vue?vue&type=script&lang=ts&"
import style0 from "./MyProfileDetails.vue?vue&type=style&index=0&id=5e668c10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e668c10",
  null
  
)

export default component.exports